import { useBrandStore } from "../stores/brandStore";

const BrandPane = () => {
    const brands = [
        { id: 1, name: "Ozempic", initial: "O" },
        { id: 2, name: "Xarelto", initial: "X" },
        { id: 3, name: "Tremfya", initial: "T" },
    ];
    const { selectedBrand, setSelectedBrand } = useBrandStore();
    return (
        <div className="w-20 bg-white border-r border-gray-200 p-4 flex flex-col items-center relative z-50">
            {brands.map((brand) => (
                <div key={brand.id} className="group relative">
                    <div
                        onClick={() => setSelectedBrand(brand.id)}
                        className={`w-12 h-12 mb-4 rounded-lg flex items-center justify-center cursor-pointer transition-colors ${
                            selectedBrand === brand.id
                                ? "bg-[#0d0450]"
                                : "bg-[#5a55f4] hover:bg-[#0d0450]"
                        }`}
                    >
                        <span className="text-white text-xl font-bold">
                            {brand.initial}
                        </span>
                    </div>
                    {/* Tooltip */}
                    <div className="absolute left-full ml-2 top-1/2 -translate-y-1/2 px-2 py-1 bg-gray-800 text-white text-sm rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity z-[9999]">
                        {brand.name}
                    </div>
                </div>
            ))}
            <div className="w-12 h-12 mb-4 bg-gray-100 rounded-lg flex items-center justify-center cursor-pointer hover:bg-gray-200 transition-colors">
                <span className="text-gray-600 text-xl font-bold">+</span>
            </div>
            {/* Tooltip */}
            <div className="absolute left-full ml-2 top-1/2 -translate-y-1/2 px-2 py-1 bg-gray-800 text-white text-sm rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity z-[9999]">
                New Brand
            </div>
        </div>
    );
};

export default BrandPane;
